import { Slideshow } from '@archetype-themes/modules/slideshow'

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.el = this
    this.url = this.dataset.url
    this.intent = this.dataset.intent
    this.placeholder = this.querySelector('.product-recommendations-placeholder')
    this.productResults = this.querySelector('.grid-product')
    this.sectionId = this.dataset.sectionId
    this.blockId = this.dataset.blockId

    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-recommendations')

        if (!recommendations) {
          this.el.classList.add('hide')
          return
        }

        this.placeholder.innerHTML = ''
        this.placeholder.innerHTML = recommendations.innerHTML

        this.slideshow = this.querySelector('[data-slideshow]')

        if (this.slideshow) {
          this.setupSlider()
        }
        
        // 🟢 Initialize Swiper after appending elements
        if (document.querySelector(".swiper__product-recommendations")) {
          new Swiper(".swiper__product-recommendations", {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 2,
            lazy: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            breakpoints: {
              640: {
                slidesPerView: 2, // On smaller screens, show 1 slide
              },
              768: {
                slidesPerView: 3, // On tablets, show 2 slides
              },
              1024: {
                slidesPerView: 4, // On larger screens, show 3 slides
                }
            },
          });
        } else {
          console.error("Swiper container not found: swiper__product-recommendations");
        }
        
      })
      .catch((e) => {
        console.error(e)
      })
  }

  setupSlider() {
    const controlType = this.slideshow.dataset.controls
    const perSlide = parseFloat(this.slideshow.dataset.perSlide)
    const count = parseFloat(this.slideshow.dataset.count)

    let prevNextButtons = false
    let pageDots = true

    if (controlType === 'arrows') {
      pageDots = false
      prevNextButtons = true
    }

    if (perSlide < count) {
      this.flickity = new Slideshow(this.slideshow, {
        prevNextButtons,
        pageDots,
        adaptiveHeight: true,
        wrapAround: false
      })
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations)
